require("../react_isomorphic/shims/Array.prototype.find");
import objectAssign from "object-assign";
window.Object.assign = objectAssign;
